import JSX from "../../helpers/react.js";

export function BBButtons(){
    return (
        <div className="bbcode">
            <div className="bordered-left default-button bb-b materiable" data-bb="bold">
                <i className="far fa-fw fa-bold"></i>
            </div>
            <div className="default-button bb-i materiable" data-bb="italic">
                <i className="far fa-fw fa-italic"></i>
            </div>
            <div className="default-button bb-u materiable" data-bb="underline">
                <i className="far fa-fw fa-underline"></i>
            </div>
            <div className="default-button bb-s materiable" data-bb="strikethrough">
                <i className="far fa-fw fa-strikethrough"></i>
            </div>
            <div className="bordered-right default-button bb-spoiler materiable" data-bb="spoiler">
                <i className="far fa-fw fa-low-vision"></i>
            </div>
        </div>
);
}
